export const USER_ADDRESS = 'user/address'
export const GUEST_ADDRESS = 'guest/address'
export const USER_ADDRESS_SET_LIST = USER_ADDRESS + '/SET_LIST'
export const USER_ADDRESS_SET_LIST_LOADER = USER_ADDRESS + '/SET_LIST_LOADER'
export const USER_ADDRESS_ADD = USER_ADDRESS + '/ADD'
export const USER_ADDRESS_UPDATE = USER_ADDRESS + '/UPDATE'
export const USER_ADDRESS_DELETE = USER_ADDRESS + '/DELETE'
export const USER_ADDRESS_SET = USER_ADDRESS + '/USER_ADDRESS_SET';
export const GUEST_ADDRESS_ADD = GUEST_ADDRESS + '/GUEST_ADDRESS_ADD'
export const GUEST_ADDRESS_UPDATE = GUEST_ADDRESS + '/GUEST_ADDRESS_UPDATE'
export const GUEST_ADDRESS_SET_LIST = GUEST_ADDRESS + '/GUEST_ADDRESS_SET_LIST'
export const GUEST_ADDRESS_SET_DEFAULT = GUEST_ADDRESS + '/GUEST_ADDRESS_SET_DEFAULT'
export const GUEST_ADDRESS_DELETE = GUEST_ADDRESS + '/DELETE'
export const GUEST_ADDRESS_CLEAR_STATE = GUEST_ADDRESS + '/CLEAR_STATE'
export const USER_ADDRESS_CLEAR_STATE_AFTER_LOGOUT = USER_ADDRESS + '/CLEAR_STATE_AFTER_LOGOUT'
